// MeetEllaIntro — short, tight lead-in to Ella's full demo.
// Mirror of MeetJohnIntro but for the Kids/family-building variant.
// Story arc: gift at baby shower → started recording day one → her chapter
// continues until she takes the pen herself in adulthood.
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Play } from "@phosphor-icons/react";
import { ForgetMeNotIcon } from "../ForgetMeNotIcon";

const FADE = {
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-100px" },
    transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
};

// Soft newborn anchor image — pink Kids variant atmosphere.
const ELLA_IMG = "/product-mockup-kids-pink.png";

export function MeetEllaIntro() {
    return (
        <section className="relative py-28 px-6 bg-gradient-to-br from-[#FDF2F4]/60 via-[#FDFBF7] to-[#FBE9EC]/40" data-testid="meet-ella" id="ella">
            <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
                <motion.div {...FADE} className="lg:col-span-5">
                    <div className="rounded-3xl overflow-hidden shadow-rem-card aspect-[4/5] bg-[#FBE9EC]">
                        <img src={ELLA_IMG} alt="Ella — from her first day, written down forever" className="w-full h-full object-cover" data-testid="ella-portrait" />
                    </div>
                    <div className="absolute -bottom-6 -right-6 hidden md:block"><ForgetMeNotIcon size={72} /></div>
                </motion.div>

                <motion.div {...FADE} transition={{ ...FADE.transition, delay: 0.12 }} className="lg:col-span-7">
                    <p className="font-sans text-xs uppercase tracking-[0.3em] text-[#D88AAB] font-semibold mb-6">
                        Meet Ella
                    </p>
                    <h2 className="font-serif text-4xl sm:text-5xl text-[#2D2B2A] leading-tight">
                        Ella is starting hers.<br/>
                        <em className="italic text-[#A6647E]">A whole life ahead — written down from day one.</em>
                    </h2>

                    <div className="mt-8 space-y-5 text-[#5C5A59] text-lg leading-relaxed font-light max-w-prose">
                        <p>
                            Mum &amp; Dad were gifted Ella's remembr — the Baby Girl edition — at her baby shower.
                        </p>
                        <p>
                            From the day she was born, they began recording her journey: photos, voices, the small ordinary moments most families assume they'll remember. Through childhood, school, milestones — every chapter sealed in Ella's voice library by the people who love her most.
                        </p>
                        <p className="text-[#2D2B2A] font-serif italic text-xl text-balance">
                            And when Ella's old enough, she takes the pen — adding her own chapters as the years carry on.
                        </p>
                    </div>

                    <div className="mt-10">
                        <Link
                            to="/demo/ella"
                            className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-[#D88AAB] hover:bg-[#A6647E] text-white font-medium text-base transition-all shadow-rem-card hover:shadow-lg hover:scale-[1.02]"
                            data-testid="meet-ella-cta"
                        >
                            <Play size={18} weight="fill" />
                            Watch Ella's session  ·  6 min
                        </Link>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
